module.exports = {
  domain: 'https://login.viatik.com',
  audience: 'https://sinnombre-renzactus.vercel.app/api',
  clientId: 'B2EXx69P03XoRjp51RaIKqOUdm9xNH7j',
  namespace: 'https://www.viatik.com/',
  auth_uri: process.env.REACT_APP_AUTH_URI,
  auth_api_uri: process.env.REACT_APP_AUTH_API_URI ?? process.env.REACT_APP_AUTH_URI,
  MARGIN_ACCESS_EXPIRATION: 60, //Si falta menos de este tiempo (en segundos) para que expire el accessToken se conseguira uno nuevo a la hora de ejecutar getAccessToken
  NAMESPACE: 'https://www.viatik.com/'
}
